import React, { useContext, useEffect } from "react";
import { Form, Formik } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { Button, Col, Row, Input } from "components/bootstrap";
import { useStore } from "stores/connect";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { StyledTitle } from "./StyledWizardComponents";
import { ForwarderWizardContext } from "./ForwarderWizardProvider";
import ForwardersStore, { ForwardersActions } from "../stores/ForwardersStore";
const ConfigureForwarderStep = ({ onStepComplete, forwarderId = void 0 }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { selectedForwarder, setSelectedForwarder } = useContext(ForwarderWizardContext);
  const { forwardersPendingConfiguration } = useStore(ForwardersStore);
  const sendTelemetry = useSendTelemetry("forwarder-create");
  useEffect(() => {
    if (forwarderId && !selectedForwarder) {
      if (forwardersPendingConfiguration.length === 0) {
        ForwardersActions.listPendingConfiguration({});
      }
      const forwarder = forwardersPendingConfiguration.find((f) => f.id === forwarderId);
      if (forwarder) {
        setSelectedForwarder(forwarder);
      }
    }
  }, [forwarderId, selectedForwarder, forwardersPendingConfiguration, setSelectedForwarder]);
  if (forwarderId && !selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, t("configure_forwarder_step.please_wait"));
  }
  if (!selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, t("configure_forwarder_step.select_forwarder_first"));
  }
  const handleSubmit = (values, { setSubmitting }) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_CONFIGURE_FORWARDER_SAVED, {
      app_pathname: "forwarder",
      app_action_value: "save"
    });
    ForwardersActions.update(selectedForwarder.id, values).then((persistedForwarder) => {
      setSelectedForwarder(persistedForwarder);
      setSubmitting(false);
      onStepComplete();
    });
  };
  const initialValues = {
    hostname: selectedForwarder.hostname,
    title: selectedForwarder.title,
    description: selectedForwarder.description
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(StyledTitle, null, t("configure_forwarder_step.heading")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "configure_forwarder_step.intro",
      values: { hostname: selectedForwarder.hostname },
      components: { em: /* @__PURE__ */ React.createElement("em", null) }
    }
  )), /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit }, ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "hostname",
      name: "hostname",
      label: t("configure_forwarder_step.hostname_label"),
      type: "text",
      value: values.hostname,
      onChange: handleChange,
      help: t("configure_forwarder_step.hostname_help"),
      required: true,
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "title",
      name: "title",
      label: t("configure_forwarder_step.title_label"),
      type: "text",
      value: values.title,
      onChange: handleChange,
      help: t("configure_forwarder_step.title_help"),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "description",
      name: "description",
      label: /* @__PURE__ */ React.createElement("span", null, t("configure_forwarder_step.description_label"), " ", /* @__PURE__ */ React.createElement("small", null, t("configure_forwarder_step.description_optional"))),
      type: "text",
      value: values.description,
      onChange: handleChange,
      help: t("configure_forwarder_step.description_help")
    }
  ), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: isSubmitting }, isSubmitting ? t("configure_forwarder_step.saving") : t("configure_forwarder_step.add_inputs"))))));
};
export default ConfigureForwarderStep;
